module.exports = __webpack_public_path__ + "static/img/smcx.ec899d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/smcx.png
// module id = YQNO
// module chunks = 1